import { styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors, transition } from '#/theme/theme';

export const TabsHorizontalHolder = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
`;

export const TabsHorizontalUl = styled.ul`
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding: 0;
  margin: 0;
  scrollbar-width: none;
  gap: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TabsHorizontalMarker = styled.div`
  position: absolute;
  overflow: hidden;
  height: 2px;
  transform: translateY(-100%);
  background: ${colors.brandBlue};
  transition: ${transition};
  z-index: 2;
`;

export const TabsHorizontalItemLi = styled.li`
  list-style: none;
  user-select: none;
  display: inline-block;
  margin: 0;
  padding: 0;
`;

export const TabsItemHorizontalButtonOrLink = styled(ButtonOrLink)`
  display: flex;
  align-items: center;
  width: 100%;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  color: ${colors.lightContentGrey};
  transition: ${transition};
  border-bottom: 2px solid transparent;
  text-decoration: none;

  &:hover {
    border-bottom: 2px solid ${colors.lightContentGrey};
  }

  &[aria-selected='true'] {
    color: ${colors.brandBlue};
  }

  &:not([data-compact]) {
    height: 47px;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
    font-size: 20px;
  }

  &[data-compact] {
    padding-bottom: 8px;
    font-size: 18px;
  }
`;
